export default "__VITE_ASSET__DOMDWFmo__"